import React from 'react';
import * as classes from './ContactListItem.module.scss';
import BorderedListItem from '../BorderedListItem/BorderedListItem';

interface Props {
  label: string;
  value: JSX.Element;
}

const ContactListItem = ({ label, value }: Props) => {
  return (
    <BorderedListItem borderOnlyBottom>
      <div className={classes.wrapper}>
        <div className={classes.nameOfContact}>{label}</div>
        <div>{value}</div>
      </div>
    </BorderedListItem>
  );
};

export default ContactListItem;
